import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  setPatientForUpdate,
  updatePatient,
} from '../../../../state/patient/patientReducer'
import { Button } from 'antd'
import { useForm } from 'antd/es/form/Form'
import styled from 'styled-components'
import '../../../../styles/antd/formStyles.css'
import { CloseCircleFilled, EditFilled, SaveFilled } from '@ant-design/icons'
import dayjs, { Dayjs } from 'dayjs'
import { usePatientContext } from '../../PatientsView'
import { usePatientTabContext } from '../../PatientTabs'
import PatientForm from '../../../Forms/PatientForm/PatientForm'

type PatientTabProps = {
  patientKey: string
}

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

const ProfileTabHeader = styled.div`
  margin: 10px 3px;
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 80%;
  align-items: center;
  justify-content: flex-start;
  & .iconButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & .anticon {
      margin-left: 0px;
    }
  }
`

const FormContainer = styled.div`
  width: 80%;
`
function ProfileTab({ patientKey }: PatientTabProps) {
  const dispatch = useDispatch()
  const { activeKey, size } = usePatientTabContext()
  const { setOpenViewStates } = usePatientContext()
  const [updateState, setUpdateState] = useState(false)
  const [form] = useForm()
  const { updateViewState } = usePatientContext()
  useEffect(() => {
    dispatch(
      setPatientForUpdate({
        key: patientKey,
        form: form,
      })
    )
  }, [])

  useEffect(() => {
    if (updateViewState) {
      setUpdateState(true)
    } else {
      setUpdateState(false)
    }
  }, [updateViewState])
  useEffect(() => {
    if (activeKey !== '6') {
      setUpdateState(false)
      setOpenViewStates((prev) => {
        let newData = { ...prev }
        newData[patientKey] = {
          ...newData[patientKey],
          updateState: false,
        }
        return { ...newData }
      })
    }
  }, [activeKey])

  function updateProfileData() {
    form.submit()
  }

  function onFinish() {
    const values = form.getFieldsValue()
    let formData = {
      ...values,
      dob: dayjs(values.dob).format('YYYY-MM-DD'),
    }
    let keys = Object.keys(formData)
    keys.forEach((key) => {
      if (formData[key] === null) {
        formData[key] = ''
      }
    })
    let currentPatientData = { ...formData, patientKey }
    dispatch(updatePatient(currentPatientData))
    setUpdateState(false)
  }

  function onCancel() {
    dispatch(
      setPatientForUpdate({
        key: patientKey,
        form: form,
      })
    )
    setUpdateState(false)
  }

  return (
    <ProfileContainer>
      <ProfileTabHeader>
        {!updateState ? (
          <Button
            type='primary'
            onClick={() => setUpdateState(true)}
            size='small'
            className='iconButton'
          >
            {' '}
            <EditFilled className='anticon' /> Update
          </Button>
        ) : (
          <>
            <Button type='primary' onClick={onCancel} size='small'>
              <CloseCircleFilled className='anticon' /> Cancel
            </Button>
            <Button type='primary' onClick={updateProfileData} size='small'>
              <SaveFilled className='anticon' /> Save
            </Button>
          </>
        )}
      </ProfileTabHeader>
      <FormContainer>
        <PatientForm
          updateType
          size={size}
          onFinish={onFinish}
          disabledState={!updateState}
          form={form}
        />
      </FormContainer>
    </ProfileContainer>
  )
}

export default ProfileTab
